import { graphql, readInlineData } from 'react-relay'
import { user_isClient$key } from '__generated__/user_isClient.graphql'
import { user_isMember$key } from '__generated__/user_isMember.graphql'
import { user_isGuest$key } from '__generated__/user_isGuest.graphql'
import { user_isRecruiterOrAdmin$key } from '__generated__/user_isRecruiterOrAdmin.graphql'
import { user_isRealAdmin$key } from '__generated__/user_isRealAdmin.graphql'
import { Nullable } from 'types'
import { user_isAdmin$key } from '__generated__/user_isAdmin.graphql'

export function isMember(userFragmentRef: Nullable<user_isMember$key>) {
  if (!userFragmentRef) return false

  const user = readInlineData(graphql`
    fragment user_isMember on User @inline {
      status
      isMember
    }
  `, userFragmentRef)

  // TODO: when unified accounts are enabled, this should probably always return true unless the user is a guest
  return Boolean(user?.isMember && user?.status !== 'deleted')
}

export function isClient(userFragmentRef: Nullable<user_isClient$key>) {
  if (!userFragmentRef) return false

  const user = readInlineData(graphql`
    fragment user_isClient on User @inline {
      status
      isClient
    }
  `, userFragmentRef)

  // TODO: when unified accounts are enabled, update this to take a firm parameter and check if I am managing that firm
  return Boolean(user?.isClient && user?.status !== 'deleted')
}

export function isAdmin(userFragmentRef: Nullable<user_isAdmin$key>) {
  if (!userFragmentRef) return false

  const user = readInlineData(graphql`
    fragment user_isAdmin on User @inline {
      roles
    }
  `, userFragmentRef)

  return Boolean(user?.roles?.includes('admin'))
}

export function isRealAdmin(userFragmentRef: Nullable<user_isRealAdmin$key>) {
  if (!userFragmentRef) return false

  const user = readInlineData(graphql`
    fragment user_isRealAdmin on User @inline {
      roles
      realUser {
        roles
      }
    }
  `, userFragmentRef)

  return Boolean(
    user?.realUser?.roles?.includes('admin') || user?.roles?.includes('admin'),
  )
}

export function isRecruiterOrAdmin(userFragmentRef: Nullable<user_isRecruiterOrAdmin$key>) {
  if (!userFragmentRef) return false

  const user = readInlineData(graphql`
    fragment user_isRecruiterOrAdmin on User @inline {
      roles
      realUser {
        roles
      }
    }
  `, userFragmentRef)

  return user?.realUser?.roles?.includes('admin') || user?.roles?.includes('admin') ||
    user?.realUser?.roles?.includes('recruiter') || user?.roles?.includes('recruiter') || false
}

export function isGuest(userFragmentRef: Nullable<user_isGuest$key>) {
  if (!userFragmentRef) return true

  const user = readInlineData(graphql`
    fragment user_isGuest on User @inline {
      guest
      status
    }
  `, userFragmentRef)

  return Boolean(!user || user?.guest || user?.status === 'deleted')
}
